import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiProcesminetoArchivosService {

  constructor(private http: HttpClient) { }

  comprobarProvision(XLSXFile: File): Observable<Object> {
    const formData = new FormData();
    formData.append('file', XLSXFile);
    return this.http.post(`${environment.api_procesamiento_archivos}/facturacion/cargueProvision/sunpower`, formData)
  }
}
